import { FC, useContext } from 'react';

import { ToucanColors } from '@jointoucan/toucan-design';
import { useTranslation } from 'next-i18next';

import Information from '~/components/shared/Dashboard/Layout/Information';
import ModalContext from '~/context/ModalContext';
import useUserAccountModals from '~/hooks/useUserAccountModals';
import { ButtonType } from '~/types';

interface SignUpInformationProps {
  onLoginSignup?: () => void;
  header?: string;
  externalAuthRedirectPath: string;
}

const SignUpInformation: FC<SignUpInformationProps> = ({
  onLoginSignup = () => {},
  header,
  externalAuthRedirectPath,
}) => {
  const { modal } = useContext(ModalContext);
  const { t } = useTranslation('dashboard');

  const onFinishModalLoginSignup = async () => {
    modal.closeModal();
    onLoginSignup();
  };

  const { showSignupSelectionModal } = useUserAccountModals({
    modalPropsForAllModals: {
      isCloseButtonVisible: true,
      closeButtonColor: ToucanColors.gray[300],
    },
    onLoginComplete: onFinishModalLoginSignup,
    onSignupComplete: onFinishModalLoginSignup,
    externalAuthRedirectPath,
  });

  return (
    <Information
      header={header ?? t('dashboardSignupDontHaveAccountYet')}
      information={t('dashboardCreateAccountSavePersonalizeLearningProgress')}
      informationMaxWidth={412}
      isInformationStacked
      buttonText={t('dashboardSignUp')}
      buttonType={ButtonType.Primary}
      onClickButton={showSignupSelectionModal}
    />
  );
};

export default SignUpInformation;
